export const ProductListResultColumnsModel = [
  {
    label: 'make',
    template: {
      type: 'content',
      property: 'make'
    },
    cellClass: 'link',
    isVisible: true,
    width: 35
  },
  {
    label: 'model',
    template: {
      type: 'content',
      property: 'model'
    },
    cellClass: 'link',
    isVisible: true,
    width: 35
  },
  {
    label: 'part number',
    property: 'partNumber',
    type: 'string',
    isVisible: true,
    width: 35
  },
  {
    label: 'requires audit',
    property: 'requiresAudit',
    type: 'boolean',
    isVisible: true,
    width: 35
  }
];
